import React from 'react';
import styled from 'styled-components';
import {Link, useLocation} from 'react-router-dom';

/* Components */
import {colors} from '../../../../common/components/colors';
import {FontSubtitle28} from '../../../../common/components/fonts';

const NavRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    column-gap: 60px;
    row-gap: 30px;
    padding-bottom: 40px;
    margin-top: 53px;
`;
const Nav = styled(Link)`
    ${props => props.active !== "true"} {
        border-bottom: 3px solid ${colors.action100};
        cursor: default;
        & div {
          font-weight: bold;
        }
    }
    ${props => props.active !== "false"} {
        border-bottom: none;
        cursor: pointer;
    }
    padding: 10px 0;
    width: fit-content;
    color: ${colors.primary100};
`;
const Bar = styled.div`
    width: 2px;
    margin: 4px 0;
    background-color: ${colors.primary100};
`;

export default function CertTrainingsNav() {
    const location = useLocation();

    return (
        <NavRow>
            <Nav
                active={(location.pathname === "/my-certificates").toString()}
                to={"/my-certificates"}
            >
                <FontSubtitle28 spaced={false}>Get Started</FontSubtitle28>
            </Nav>
            {/*<Bar />*/}
            {/*<Nav*/}
            {/*    active={(location.pathname === "/my-certificates/benefits").toString()}*/}
            {/*    to={"/my-certificates/benefits"}*/}
            {/*>*/}
            {/*    <FontSubtitle28 spaced={false}>Benefits</FontSubtitle28>*/}
            {/*</Nav>*/}
            {/*<Nav*/}
            {/*    active={(location.pathname.includes("/my-certificates/my-trainings")).toString()}*/}
            {/*    to={"/my-certificates/my-trainings"}*/}
            {/*>*/}
            {/*    <FontSubtitle28 spaced={false}>My Trainings</FontSubtitle28>*/}
            {/*</Nav>*/}
            {/*<Bar />*/}
            {/*<Nav*/}
            {/*    active={(location.pathname.includes("/my-certificates/my-coaches")).toString()}*/}
            {/*    to={"/my-certificates/my-coaches"}*/}
            {/*>*/}
            {/*    <FontSubtitle28 spaced={false}>My Coaches</FontSubtitle28>*/}
            {/*</Nav>*/}
            {/*<Bar />*/}
            {/*<Nav*/}
            {/*    active={(location.pathname.includes("/my-certificates/profile")).toString()}*/}
            {/*    to={"/my-certificates/profile"}*/}
            {/*>*/}
            {/*    <FontSubtitle28 spaced={false}>My Profile</FontSubtitle28>*/}
            {/*</Nav>*/}
            {/*<Bar />*/}
            {/*<Nav*/}
            {/*    active={(location.pathname === "/my-certificates/manage").toString()}*/}
            {/*    to={"/my-certificates/manage"}*/}
            {/*>*/}
            {/*    <FontSubtitle28 spaced={false}>Manage my membership</FontSubtitle28>*/}
            {/*</Nav>*/}

        </NavRow>
    )
}
